// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import $ from 'jquery'
import jQuery from 'jquery'
window.$ = $
window.jQuery = jQuery

import moment from 'moment';
import 'tempusdominus-bootstrap-4';
import 'bootstrap';

window.toastr = toastr

Rails.start()
Turbolinks.start()
ActiveStorage.start()

document.addEventListener('DOMContentLoaded', () => {
  const flash = document.getElementById('flash');
  if (!flash) return;

  const success = flash.dataset.flashSuccess;

  if (success) toastr.success(success);
});

document.addEventListener('turbolinks:load', () => {
  const hamburger = document.getElementById('hamburger');
  const sidebar = document.getElementById('sidebar');
  
  if (!hamburger || !sidebar) return;

  hamburger.addEventListener('click', () => {
    sidebar.classList.toggle('open');
  })
});
